import Vue from "vue";
// eslint-disable-next-line
import Vuetify from "vuetify/lib";
import de from "../locale/de";
import en from "../locale/en";
import it from "../locale/it";
import es from "../locale/es";
import ru from "../locale/ru";
import fr from "../locale/fr";

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { de, en, it, es, ru, fr },
    current: "de"
  }
});
